import { Outlet } from "react-router-dom";

export default function CodeGroupsOutlet() {
  return <Outlet />;
}
